import PropTypes from 'prop-types';
import { classes } from '@/helpers/styling';

// A header bar which is fixed to the top of the screen
// Renders the passed children inside of it
const HeaderBar = ({
  children,
  style,
  className
}) => {
  return (
    <div
      className={ classes('header-bar', className) }
      data-nosnippet=''
      data-testid='header-bar'
      style={ style }
    >
      { children }
    </div>
  );
};

HeaderBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  style: PropTypes.object,
  className: PropTypes.string
};

HeaderBar.defaultProps = {
  style: {},
  className: ''
};

export default HeaderBar;